import React from "react";

const ViewButton = ({ title, Icon, onClick }) => {
    return (
        <button onClick={onClick} className="text-[#212121] text-lg font-medium flex items-center gap-1">
            <span className="">
                {title}
            </span>
            {Icon && <Icon className="text-current text-lg" />}
        </button>
    );
};

export default ViewButton;
